import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Router } from "react-router-dom";
import { Timeout } from "../components/auth/timeout";
import history from "../history";
import { isTokenValid } from "../services/jwtParser";

/**
 * const getUserConfirmation = (message, callback) => {
 *   const allow = window.confirm(message);
 *   callback(allow);
 * };
 */

const BrowserContainer = ({ accessToken, children }) => {
  const [validToken, setValidToken] = useState(true);

  useEffect(() => {
    
    if (accessToken) {
      const valid = isTokenValid(accessToken);
      setValidToken(valid);
    }
  }, []);

  if (!validToken) {
    return <Timeout />;
  }

  return (
    <div className="App">
      <Router
        history={history}
        basename="/"
        //getUserConfirmation={getUserConfirmation}
      >
        {children}
      </Router>
    </div>
  );
};

BrowserContainer.propTypes = {
  accessToken: PropTypes.string.isRequired,
};

export default BrowserContainer;
